import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=ca4313ce&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=ca4313ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4313ce",
  null
  
)

export default component.exports